/**
 * Created by jonas on 2021-06-02.
 */
import {DasUBootSymbol} from "../DasUBootSymbol";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootStatics} from "../../utils/DasUBootStatics";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";
import {gsap} from "gsap";

export class SpineSymbol extends DasUBootSymbol {

    private _spine:PIXI.spine.Spine;
    private spineName:string;
    private lastQueuedAnimation:{[index:string]:string} = {};

    constructor(reel:DasUBootReel, symbolName:string, spineName:string) {
        super(reel, symbolName);
        this.spineName = spineName;
    }

    get spine():PIXI.spine.Spine {
        if (this._spine == undefined) {
            this._spine = this.createSpine();
        }
        return this._spine;
    }

    private createSpine():PIXI.spine.Spine {
        const spine = DasUBoot.graphicsPool.getSpinePool(this.spineName).withdraw();
        spine.position.set(DasUBootStatics.symbolWidth * 0.5, DasUBootStatics.symbolHeight * 0.5 * this.resizeScale);
        spine.autoUpdate = true;
        return spine;
    }

    public addSpineToView(masked:boolean = false) {
        if (masked) {
            this.maskedView.addChild(this.spine);
            this.maskedView.addChild(this._whiteOverlay);
            this.spine.position.set(DasUBootStatics.symbolWidth * 0.5, DasUBootStatics.symbolHeight * 0.5);
            this._whiteOverlay.position.set(DasUBootStatics.symbolWidth * 0.5, DasUBootStatics.symbolHeight * 0.5);
        } else {
            this.view.addChild(this.spine);
            this.maskedView.addChild(this._whiteOverlay);
            this.spine.position.set(DasUBootStatics.symbolWidth * 0.5 * this._scaleMask.scale.x, DasUBootStatics.symbolHeight * 0.5 * this._scaleMask.scale.y);
            this._whiteOverlay.position.set(DasUBootStatics.symbolWidth * 0.5, DasUBootStatics.symbolHeight * 0.5);
        }
        this.spine.updateTransform();
    }

    public removeSpineFromView() {
        if (this._spine && this._spine.parent) {
            SpineGSAPWrapper.clearAllTracks(this._spine);
            this._spine.parent.removeChild(this._spine);
            this.lastQueuedAnimation = {};
        }
    }

    destroy(options?:{children?:boolean; texture?:boolean; baseTexture?:boolean}) {
        if (this._stateAnimation) {
            this._stateAnimation.kill();
        }

        if (this._spine) {
            this.removeSpineFromView();
            this._spine.autoUpdate = false;
            DasUBoot.graphicsPool.getSpinePool(this.spineName).deposit(this._spine);
        }
        this.lastQueuedAnimation = {};
        super.destroy(options);
    }


    protected getSpineAnimation(anim:string, track:number, masked:boolean, loopCount:number = 0):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.addSpineToView(masked);
        });

        if (anim != this.lastQueuedAnimation[track]){
            tl.add(SpineGSAPWrapper.createTimeline(this.spine, track, anim, loopCount));
            this.lastQueuedAnimation[track] = anim;
        }

        return tl;
    }


}